import { CardMedia, Paper } from '@mui/material';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { ExternalUrls } from '@/constants';
import { useUser } from '@/data/user';
import { useBootstrapData } from '@/data/user/bootstrap-data';
import { useSetTitle } from '@/hooks/use-set-title';
import { Features } from '@/models/bootstrap/plan';

const iframeHeight = 6400;
const title = 'Relatórios';

export const Dashboard = () => {
  useSetTitle(title);

  const { user } = useUser();
  const { bootstrap } = useBootstrapData();
  const companyUuid = user?.colaborador?.empresa?.uuid;
  const userFeatures = bootstrap?.plan?.features;
  const isMockedReport = userFeatures?.some(
    (feature) => feature.name === Features.Demo
  );

  const lookerParams = {
    'ds88.company_uuid': companyUuid,
    'ds138.company_uuid': companyUuid,
    'ds144.company_uuid': companyUuid,
    'ds236.company_uuid': companyUuid,
    'ds256.company_uuid': companyUuid,
    'ds258.company_uuid': companyUuid,
    'ds260.company_uuid': companyUuid,
  };

  const lookerParamsAsString = JSON.stringify(lookerParams);
  const encodedLookerParams = encodeURIComponent(lookerParamsAsString);

  const reportUrl = isMockedReport
    ? ExternalUrls.MockedLookerDashboard
    : ExternalUrls.LookerDashboard;

  return (
    <PageContainer>
      <PageHeader title={title} />
      <Paper style={{ padding: '32px' }}>
        <CardMedia
          component="iframe"
          src={`${reportUrl}?params=${encodedLookerParams}`}
          sx={{ border: 0, height: iframeHeight }}
        />
      </Paper>
    </PageContainer>
  );
};
